

import { Button, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import { hideLoading, showLoading } from "../../../../loading";
import { errorToast } from "../../../../toast";
import request from "../../../../request";
import swal from "sweetalert";
import { formatMoney } from "../../../../../../shared/utils";
import { requestConfirmation } from "../../../../utils";


export default class AdjustOwing extends Component {

   state = {
      unpaid_principal: 0,
      unpaid_interest: 0
   }

   submit = async () => {
      
      // validate
      const txtUnpaidPrincipal = document.getElementById('txt-unpaid-principal');
      const txtUnpaidInterest = document.getElementById('txt-unpaid-interest');
      const unpaid_principal = parseFloat(this.state.unpaid_principal) || 0;
      const unpaid_interest = parseFloat(this.state.unpaid_interest) || 0;
      
      if (txtUnpaidPrincipal.value === '') {
         errorToast("Please provide the unpaid principal");
         return txtUnpaidPrincipal.focus();
      }
      
      if (txtUnpaidInterest.value === '') {
         errorToast("Please provide the unpaid interest");
         return txtUnpaidInterest.focus();
      }

      const owing = unpaid_principal + unpaid_interest;

      if (owing === this.props.owing && unpaid_interest === this.props.unpaid_interest)
         return errorToast('No changes');

      if (owing === 0) {
         const confirm = await requestConfirmation('Are you sure that you want to set owing to zero. This will mark the loan as COMPLETE');
         if (!confirm)
            return;
      }

      try {

         showLoading();

         const data = { owing, unpaid_interest }

         const res = await request.put(`/api/finance/loans/${this.props.loanId}/owing`, data);
         this.props.onClose(res.data);

      } catch (error) {
         swal('Error', error.message, 'error');
      } finally {
         hideLoading();
      }
   }

   componentDidMount() {
      const { unpaid_interest, owing } = this.props;
      this.setState({
         unpaid_principal: owing - unpaid_interest,
         unpaid_interest,
      });
   }

   render() {
      return <Dialog open>
         <DialogTitleWithCloseButton onClose={() => this.props.onClose()}>
            Adjust Amount Owed
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="w-[250px] max-w-full flex flex-col gap-8">
               <div className="bg-red-50 rounded text-red-600 text-xs font-bold px-4 py-2">
                  This operation does not affect Quickbooks
               </div>
               <TextField
                  id="txt-unpaid-principal"
                  label="Unpaid principal"
                  variant="outlined"
                  size="small"
                  value={this.state.unpaid_principal}
                  onChange={e => this.setState({ unpaid_principal: e.target.value })}
                  type="number"
               />
               <TextField
                  id="txt-unpaid-interest"
                  label="Unpaid interest"
                  variant="outlined"
                  size="small"
                  value={this.state.unpaid_interest}
                  onChange={e => this.setState({ unpaid_interest: e.target.value })}
                  type="number"
               />

               <div className="text-right">
                  Owing: <b>{formatMoney(parseFloat(this.state.unpaid_principal) + parseFloat(this.state.unpaid_interest))}</b>
               </div>
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={this.submit} variant="contained" size="small">
               SUBMIT
            </Button>
         </DialogActions>
      </Dialog>
   }
}